import { useEffect } from 'react';

const DEFAULT_TITLE = 'Menù Digitale';
const DEFAULT_DESCRIPTION = 'Consulta il menù digitale - Powered by Km zero web marketing.';

/**
 * Sets document title and meta tags for public menu pages so shared links show correct preview.
 * Title: "Menù Digitale, [restaurant name]"
 * Description: "Consulta il menù digitale di [restaurant name] - Powered by Km zero web marketing."
 */
export function usePublicMenuMeta(restaurantName: string | undefined | null): void {
  useEffect(() => {
    const name = restaurantName?.trim() || '';
    const title = name ? `Menù Digitale, ${name}` : DEFAULT_TITLE;
    const description = name
      ? `Consulta il menù digitale di ${name} - Powered by Km zero web marketing.`
      : DEFAULT_DESCRIPTION;

    const previousTitle = document.title;
    document.title = title;

    const setMetaProperty = (property: string, content: string) => {
      let el = document.querySelector<HTMLMetaElement>(`meta[property="${property}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    // Standard description
    let descEl = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!descEl) {
      descEl = document.createElement('meta');
      descEl.setAttribute('name', 'description');
      document.head.appendChild(descEl);
    }
    descEl.setAttribute('content', description);

    // Open Graph (Facebook, LinkedIn, etc.)
    setMetaProperty('og:title', title);
    setMetaProperty('og:description', description);

    // Twitter
    let twTitle = document.querySelector<HTMLMetaElement>('meta[name="twitter:title"]');
    if (!twTitle) {
      twTitle = document.createElement('meta');
      twTitle.setAttribute('name', 'twitter:title');
      document.head.appendChild(twTitle);
    }
    twTitle.setAttribute('content', title);

    let twDesc = document.querySelector<HTMLMetaElement>('meta[name="twitter:description"]');
    if (!twDesc) {
      twDesc = document.createElement('meta');
      twDesc.setAttribute('name', 'twitter:description');
      document.head.appendChild(twDesc);
    }
    twDesc.setAttribute('content', description);

    return () => {
      document.title = previousTitle;
    };
  }, [restaurantName]);
}
